import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
import { AzureService } from 'src/app/core/auth/azure.service'

const RECO_BASE_URL = environment.BASE_URL + 'recoomendationpricing/'
const CAPPING_BASE_URL = environment.BASE_URL

@Injectable({
  providedIn: 'root',
})
export class RecommendedPricingService {
  private http = inject(HttpClient);
  private azureService = inject(AzureService);

  getQuoteLine(liveQuoteId: string): Observable<any> {
    const url = `${CAPPING_BASE_URL}get-quoteline?sf_quote_id=${liveQuoteId}`;
    const headers = new HttpHeaders({
      'X-Business-Id': this.azureService.selectedBusinessArea.value || '',
    });
    const res = this.http.get(url, { headers });
    return res;
  }

  getLiveQuotes(): Observable<any> {
    const url = `${RECO_BASE_URL}get-live-quotes`;
    const res = this.http.get(url);
    return res;
  }
}
